<template>
  <div style="padding: 20px" id="mapp">
    <div>
      <span>
      количество объектов на канвасе:  {{ canvas ? canvas.getObjects().length : 0 }}
    </span> |
      <span style="margin-left: 50px;">
      zoom: {{ canvas ? canvas.getZoom() : 0 }}
    </span>
      <span style="margin-left: 5px;">
      width: {{ canvas ? canvas.getWidth() : 0 }}
    </span>
      <span style="margin-left: 5px;">
      height: {{ canvas ? canvas.getHeight() : 0 }}
    </span>
      <span style="margin-left: 5px;">
      top: {{ canvas ? canvas._offset.top : 0 }}
    </span>
      <span style="margin-left: 5px;">
      left: {{ canvas ? canvas._offset.left : 0 }}
    </span>
      <span style="margin-left: 5px;">
      свойство канваса / выделение объектов: {{ canvas ? canvas.selection ? 'вкл' : 'выкл' : 0 }}
    </span>
      <span style="margin-left: 5px;">
     this.currentMode  {{ currentMode }}
    </span>
    </div>

    <div style="border:1px grey solid; margin: 5px 0; display:flex;">
      <div style="margin: 5px">
        <v-icon @click="setCurrentMode(modes.polyline )">mdi-vector-point</v-icon>
      </div>
      <div style="margin: 5px">
        <v-icon @click="addCanvasElement('fabric-line')">mdi-vector-line</v-icon>
      </div>
      <div style="margin: 5px 35px 5px 5px">
        <v-icon @click="addCanvasElement('fabric-polyline')">mdi-vector-polyline</v-icon>
      </div>
      <div style="margin: 5px">
        <v-icon @click="addCanvasElement('fabric-rectangle')">mdi-border-all-variant</v-icon>
      </div>
      <div style="margin: 5px">
        <v-icon @click="addCanvasElement('fabric-circle')">mdi-checkbox-blank-circle-outline</v-icon>
      </div>
      <div style="margin: 5px">
        <v-icon @click="addCanvasElement('fabric-text')">mdi-format-text-variant</v-icon>
      </div>
      <div style="margin: 5px">
        <v-icon @click="addCanvasElement('fabric-image-from-url')">mdi-image-outline</v-icon>
      </div>

      <div style="margin: 5px">
        <v-icon @click="addCanvasElement('fabric-triangle')">mdi-triangle-outline</v-icon>
      </div>


      <div style="margin: 5px 5px 5px 50px">
        <v-icon @click="setCurrentMode(null)">mdi-cursor-default</v-icon>
      </div>
      <div style="margin: 5px">
        <v-icon @click="setCurrentMode(modes.pan)">mdi-arrow-all</v-icon>
      </div>


      <div style="margin: 5px; margin-left: 500px; float:right;">
        <v-icon @click="createLineGrid">mdi-grid</v-icon>
      </div>
      <div style="margin: 5px;">
        <v-icon @click="copyElement"
                :disabled="canvas && !canvas.getActiveObjects().length ">mdi-content-copy
        </v-icon>
      </div>
      <div style="margin: 5px;">
        <v-icon @click="visibleActiveElement"
                :disabled="canvas && !canvas.getActiveObjects().length">mdi-eye
        </v-icon>
      </div>
      <div style="margin: 5px;">
        <v-icon
          @click="setFillElementCanvas('#c4554e')"
          color="#c4554e"
          :disabled="canvas && !canvas.getActiveObjects().length"
        >
          mdi-checkbox-blank-circle
        </v-icon>
        <v-icon
          @click="setFillElementCanvas('#89c44e')"
          color="#89c44e"
          :disabled="canvas && !canvas.getActiveObjects().length "
        >
          mdi-checkbox-blank-circle
        </v-icon>
        <v-icon
          @click="setFillElementCanvas('#4ec4c4')"
          color="#4ec4c4"
          :disabled="canvas && !canvas.getActiveObjects().length"
        >
          mdi-checkbox-blank-circle
        </v-icon>
      </div>
      <div style="margin: 5px;">
        <v-icon
          @click="setStrokeElementCanvas('#c4554e')"
          color="#c4554e"
          :disabled="canvas && !canvas.getActiveObjects().length "
        >
          mdi-checkbox-blank-circle-outline
        </v-icon>
        <v-icon
          @click="setStrokeElementCanvas('#89c44e')"
          color="#89c44e"
          :disabled="canvas && !canvas.getActiveObjects().length "
        >
          mdi-checkbox-blank-circle-outline
        </v-icon>
        <v-icon
          @click="setStrokeElementCanvas('#4ec4c4')"
          color="#4ec4c4"
          :disabled="canvas && !canvas.getActiveObjects().length "
        >
          mdi-checkbox-blank-circle-outline
        </v-icon>
      </div>
      <div style="margin: 5px;">
        <v-icon
          @click="setUpDownElementCanvas(true)"
          color="#565656"
          :disabled="canvas && canvas.getActiveObjects().length !==1"
        >
          mdi-arrow-up-thick
        </v-icon>
        <v-icon
          @click="setUpDownElementCanvas(false)"
          color="#565656"
          :disabled="canvas && canvas.getActiveObjects().length !==1"
        >
          mdi-arrow-down-thick
        </v-icon>
        <v-icon
          @click="deleteElementCanvas()"
          color="#565656"

        >
          mdi-delete
        </v-icon>
        <v-icon
          @click="lockElementCanvas()"
          color="#565656"

        >
          mdi-lock
        </v-icon>
      </div>

    </div>

    <div id="wrapper">
      <div id="buildZone" @wheel.prevent="wheel">

        <canvas id="canvas"></canvas>
        <div id="controls1">
          <div style="margin: 10px;">
            <span style="cursor:pointer;" @click="createObjCanvasTest(1000)">[добавить 1000]</span><br>
            <span style="cursor:pointer;" @click="createObjCanvasTest(50)">[добавить 50]</span><br>
            <span style="cursor:pointer;" @click="createObjCanvasTest(5)">[добавить 5]</span><br>
            <span style="cursor:pointer;" @click="clearObjCanvasTest()">[удалить все]</span>

              <div class="" v-if="canvas">
                <div
                  :style="{
                  height:'20px',
                  margin:'10px',
                  padding:'2px',
                  backgroundColor:obj.fill
                  }"
                  v-for="obj in canvas.getObjects().reverse()" :key="obj.id">
                  {{obj.type}} - {{obj.id}}
                </div>
              </div>
          </div>
          <div class="" style="width:350px; font-size:14px;overflow:hidden;"
               v-if="canvas">

            <div

              style="display:flex;cursor:pointer; margin: 5px;  padding: 3px; border-radius: 5px;border:1px dashed grey; "
              v-for="(object,ind) in ObjectCanvas"
              :key="object.id"
            >{{ ind }}
              <div @click.stop="setVisibleObject(object)">
                <!--                                <v-icon small>{{object.visible ? 'mdi-home' : 'mdi-plus'}}</v-icon>-->
                {{ object.active }}
              </div>
              <div @click.stop="setActiveObject(object)">
                <!--                                <v-icon small style="margin-left: 10px">{{ object.icon  || 'mdi-home'}}</v-icon>-->
                {{ object.type || ' - ' }}
              </div>
            </div>
            <!--            <pre>-->
            <!--&lt;!&ndash;               {{canvas ? canvas.getObjects(): ' - '}}&ndash;&gt;-->
            <!--               {{ canvas ? canvas.getActiveObject() : ' - ' }}-->
            <!--            </pre>-->

          </div>
        </div>
      </div>
      <div id="styleZone"></div>
    </div>

  </div>
</template>

<script>
import {fabric} from 'fabric'


export default {
  name: "App",
  data() {
    return {
      testI:1,
      ObjectCanvas: [],
      canvas: null,
      canvasWidth: 1500,
      canvasHeight: 800,
      canvasMousePress: false,
      currentMode: null,
      currentKey: null,
      modes: {
        default: 'default',
        pan: 'pan',
        drawing: 'drawing',
        polyline: 'polyline'
      },
      currentPolyLine: null
    };
  },
  mounted() {
    this.canvas = new fabric.Canvas('canvas',
      {
        width: this.canvasWidth,
        height: this.canvasHeight,
        backgroundColor: 'white',
        selection: false
      });
    const holst = new fabric.Rect({
      name: 'holst',
      selectable: false,
      id: this.$uuid.v1(),
      strokeWidth: 1,
      stroke: 'rgba(11,185,201,0.38)',
      fill: 'rgb(249,251,252)',
      width: this.canvasWidth,
      height: this.canvasHeight,
      left: 0,
      top: 0
    });
    this.canvas.add(holst)
    this.canvas.on('mouse:over', this.canvasMouseOver)
    this.canvas.on('mouse:up', this.canvasMouseUp)
    this.canvas.on('mouse:down', this.canvasMouseDown)
    this.canvas.on('mouse:out', this.canvasMouseOut)
    this.canvas.on('mouse:move', this.canvasMouseMove)

  },
  created: function () {
    window.addEventListener('keydown', this.keydown)
    window.addEventListener('keyup', this.keyup)
  },
  destroyed: function () {
    window.removeEventListener('keydown', this.keydown)
    window.removeEventListener('keyup', this.keyup)
  },
  methods: {
    // ---------------------------------------------
    //press key

    keydown(e) {
      console.log(e.code)
      if (e.code === 'Space') {
        e.preventDefault()
        this.currentMode = this.modes.pan
        this.canvas.setCursor('grab')
        this.canvas.renderAll()
        this.setSelectionElementCanvas(false)
      }
      if (e.code === 'KeyP') {
        e.preventDefault()
        this.currentMode = this.modes.drawing
        this.canvas.setCursor('default')
        this.canvas.renderAll()
      }
      if (e.code === 'Delete') {
        e.preventDefault()
        this.deleteElementCanvas()
      }
    },
    keyup(e) {
      this.setSelectionElementCanvas(true)
      this.currentMode = null
      this.canvas.isDrawingMode = false
      this.canvas.setCursor('default')
      this.canvas.renderAll()

    },


    // ------------------------------------------------
    // mouse event from canvas
    // ------------------------------------------------
    canvasMouseOver() {
      this.MouseInCanvas = true
      // console.log('canvasMouseOver')
    },
    canvasMouseOut() {
      // console.log('canvasMouseOut')
    },
    canvasMouseDown(e) {
      this.canvasMousePress = true

      if (this.currentMode === this.modes.polyline) {
        this.currentPolyLine.path[this.currentPolyLine.path.length] = ['L', e.absolutePointer.x, e.absolutePointer.y];
        this.currentPolyLine.setCoords()
        let dims = this.currentPolyLine._calcDimensions()
        this.currentPolyLine.set({
          width: dims.width,
          height: dims.height,
          left: dims.left,
          top: dims.top,
          pathOffset: {
            x: dims.width / 2 + dims.left,
            y: dims.height / 2 + dims.top
          },
          dirty: true
        })
        this.canvas.renderAll()
      }
    },
    canvasMouseUp() {
      this.canvasMousePress = false
    },
    canvasMouseMove(event) {
      // if (this.currentMode === this.modes.polyline) {
      //   if( this.currentPolyLine.path.length){
      //     this.currentPolyLine.path[1] = ['L', event.absolutePointer.x, event.absolutePointer.y];
      //     this.canvas.renderAll()
      //   }
      // }

      if (this.canvasMousePress && this.currentMode === this.modes.pan) {
        this.canvas.selection = false
        this.canvas.setCursor('grab')
        this.canvas.renderAll()
        const mEvent = event.e
        const delta = new fabric.Point(mEvent.movementX, mEvent.movementY)
        this.canvas.relativePan(delta)
      } else if (this.canvasMousePress && this.currentMode === this.modes.drawing) {
        this.canvas.isDrawingMode = true
        this.canvas.renderAll()
      }

    },
    wheel(e) {
      let delta = e.deltaY;
      let zoom = this.canvas.getZoom();

      zoom *= 0.999 ** delta;


      if (zoom > 20) zoom = 20;
      if (zoom < 0.5) zoom = 0.5;

      this.canvas.zoomToPoint({x: e.offsetX, y: e.offsetY}, zoom);
      // this.canvas.zoomToPoint({x: e.absolutePointer.x, y: e.absolutePointer.y}, zoom);

      e.preventDefault();
      e.stopPropagation();

      // let vpt = this.canvas.viewportTransform;
      //
      // if (zoom < 400 / 1000) {
      //   vpt[4] = 200 - 1000 * zoom / 2;
      //   vpt[5] = 200 - 1000 * zoom / 2;
      // } else {
      //   if (vpt[4] >= 0) {
      //     vpt[4] = 0;
      //   } else if (vpt[4] < this.canvas.getWidth() - 1000 * zoom) {
      //     vpt[4] = this.canvas.getWidth() - 1000 * zoom;
      //   }
      //   if (vpt[5] >= 0) {
      //     vpt[5] = 0;
      //   } else if (vpt[5] < this.canvas.getHeight() - 1000 * zoom) {
      //     vpt[5] = this.canvas.getHeight() - 1000 * zoom;
      //   }
      // }

    }
    // ------------------------------------------------
    ,
    visibleActiveElement() {
      this.canvas.getActiveObjects().map((element)=>{
        element.visible = !element.visible

      })
      this.canvas.discardActiveObject()
      this.canvas.renderAll()
    },
    setFillElementCanvas(color){
      this.canvas.getActiveObjects().map((ele)=>{
       ele.set('fill',color)
      })
      this.canvas.renderAll()
    },
    setStrokeElementCanvas(color){
      this.canvas.getActiveObjects().map((ele)=>{
        ele.set('stroke',color)
      })
      this.canvas.renderAll()
    },
    setUpDownElementCanvas(bool){
      const activeObj = this.canvas.getActiveObject();
      console.log(activeObj && this.canvas.getObjects().indexOf(activeObj));
      console.log(this.canvas.getObjects().map(ele=>ele.type));
      if(bool){
        this.canvas.moveTo(activeObj ,this.canvas.getObjects().indexOf(activeObj)+1);
      } else {
        this.canvas.moveTo(activeObj ,this.canvas.getObjects().indexOf(activeObj)-1);
      }
      console.log(this.canvas.getObjects().map(ele=>ele.type));
      this.canvas.renderAll()
    },
    deleteElementCanvas(){
      this.canvas.getActiveObjects().map((ele)=>{
        this.canvas.remove(ele)
      })
      this.canvas.discardActiveObject()
      this.canvas.renderAll()
    },
    lockElementCanvas(){
      this.canvas.getActiveObjects().map((ele)=>{
        ele.selectable = false;
      })
      this.canvas.discardActiveObject()
      this.canvas.renderAll()
    },

    // test
    clearObjCanvasTest() {
      this.canvas.getObjects().map((ele) => {
        if (ele.name !== 'holst') {
          this.canvas.remove(ele)
        }

      })
      this.ObjectCanvas = []
    },
    createObjCanvasTest(num) {
      this.testI ++
      for (let i = 0; i < num; i++) {
        let id = this.$uuid.v1()
        let obj = new fabric.Rect({
          name:i,
          id: id,
          strokeWidth: 1,
          stroke: 'red',
          fill: 'grey',
          width: 40,
          height: 40,
          left: 10 + i * 5 * this.testI,
          top: 10 + i * 5 * this.testI
        })
        this.canvas.add(obj);
        this.ObjectCanvas.push(JSON.parse(JSON.stringify({id: obj.id, type: obj.type})))
      }
    },
    // end test
    //--------------------------------------------------------
    // mode
    setCurrentMode(item) {
      this.currentMode = item

      if (!item) {
        this.canvas.selection = true
        this.canvas.renderAll()
        this.setSelectionElementCanvas(true)
        this.setOpacityElementCanvas(1)
        this.canvas.renderAll()
      }

      if (this.currentMode === this.modes.polyline) {
        this.setOpacityElementCanvas(0.5)
        this.currentPolyLine = new fabric.Path('', {
          stroke: 'grey',
          strokeWidth: 1,
          fill: 'white',
          top: 50,
          left: 200
        });
        this.canvas.setCursor('default')
        this.canvas.add(this.currentPolyLine);
        this.setSelectionElementCanvas(false)
        this.canvas.selection = false
        this.canvas.renderAll()
      }
      if (this.currentMode === this.modes.pan) {
        this.setSelectionElementCanvas(false)
        this.canvas.selection = false
        this.canvas.renderAll()
      }

    },
    // ------------------------------------------------------
    //zoom
    zoomPlus() {
      this.canvas.setZoom(this.zoom++)
    },
    setZoom(num) {
      this.canvas.setZoom(num)
    },

    //-----------------------------------------------------------------
    // work with element

    setSelectionElementCanvas(bool) {

        this.canvas.forEachObject(function (o) {
          if (o.name !== 'holst') {
            o.hasBorders = o.hasControls = bool;
          }
        });

    },
    setOpacityElementCanvas(num) {

        this.canvas.forEachObject(function (o) {
          if (o.name !== 'holst') {
            o.opacity = num
          }
        });

    },
    addCanvasElement(type) {
      let element;
      switch (type) {
        case 'fabric-text':
          let text = new fabric.Text("Привет", {
            fontSize: 20,
            textAlign: 'center',
            id: this.$uuid.v1(),
            strokeWidth: 1,
            fill: "black",
            width: 150,
            height: 100,
            left: 10,
            top: 10
          })
          console.log(text)
          this.canvas.add(text);
          break;
        case 'fabric-circle':
          this.canvas.add(new fabric.Circle({
            name: "круг",
            icon: "mdi-circle-outline",
            radius: 50,
            id: this.$uuid.v1(),
            strokeWidth: 1,
            stroke: 'grey',
            fill: 'transparent',
            width: 100,
            height: 100,
            left: 10,
            top: 10
          }));
          break;
        case 'fabric-rectangle':
          this.canvas.add(new fabric.Rect({
            id: this.$uuid.v1(),
            strokeWidth: 1,
            stroke: 'grey',
            fill: 'transparent',
            width: 100,
            height: 100,
            left: 10,
            top: 10
          }));

          break;
        case 'fabric-line':
          this.canvas.add(new fabric.Line([10, 10, 100, 100], {
            left: 10,
            top: 10,
            stroke: 'grey'
          }));
          break;
        case 'fabric-triangle':
          this.canvas.add(new fabric.Triangle({
            top: 10,
            left: 10,
            width: 150,
            height: 100,
            fill: '',
            stroke: 'grey',
            strokeWidth: 1,
            id: this.$uuid.v1(),
            angle: 0,
          }));
          break;
        case 'fabric-polyline':
          this.canvas.add(new fabric.Polyline([{
            x: 200,
            y: 10
          }, {
            x: 250,
            y: 50
          }, {
            x: 250,
            y: 180
          }, {
            x: 150,
            y: 180
          }, {
            x: 150,
            y: 50
          }, {
            x: 200,
            y: 10
          }], {
            id: this.$uuid.v1(),

            fill: 'white',
            stroke: 'grey'
          }));
          break;
        case 'fabric-image-from-url':
          fabric.Image.fromURL('data:image/png;base64,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',
            (img) => {
              this.canvas.add(img).renderAll();
            }, {
              id: this.$uuid.v1(),
              left: 10,
              top: 10,
              angle: 0
            })
          break;
        default:
          this.canvas.add(new fabric.Rect({
            id: this.$uuid.v1(),
            strokeWidth: 1,
            stroke: 'grey',
            fill: 'transparent',
            width: 100,
            height: 100,
            left: 10,
            top: 10
          }));
      }
    },
    copyElement() {
      let object;
      this.canvas.getActiveObject().clone((cloned) => {
        object = cloned
      })
      this.canvas.discardActiveObject()
      object.set({
        top: object.top + 15,
        left: object.left + 15,
        id: this.$uuid.v1()
      });
      this.canvas.add(object);
      this.canvas.setActiveObject(object)
    },
    setVisibleObject(object) {
      let obj = this.getObjectByCanvasObject(object)
      obj.set('visible', !obj.visible)
      this.canvas.discardActiveObject()
      this.canvas.renderAll()
    },
    getIndexFromCanvasObjects(object) {
      return this.canvas.getObjects().map((x) => {
        return x.id
      }).indexOf(object.id)
    },
    getObjectFromCanvasObjectsByIndex(index) {
      return this.canvas.item(index);
    },
    getObjectByCanvasObject(object) {
      const index = this.getIndexFromCanvasObjects(object)
      return this.getObjectFromCanvasObjectsByIndex(index)
    },
    setActiveObject(object) {
      let obj = this.getObjectByCanvasObject(object)
      this.activeObject = obj
      this.canvas.setActiveObject(obj);
      this.canvas.renderAll()
    },

    // ---------------------------
    // grid
    createLineGrid() {
      let groupLineGrid = new fabric.Group('', {
        objectCaching: false,
        hasControls: false,
        hasBorders: false,
        hasRotatingPoint: false,
        subTargetCheck: false,
        selectable: false
      })
      const gridsize = 20;
      for (let x = 1; x < (this.canvas.width / gridsize); x++) {

        groupLineGrid.addWithUpdate(new fabric.Line([gridsize * x, 0, gridsize * x, this.canvas.height], {
          stroke: "#DCEAEAFF",
          strokeWidth: 1,
          selectable: false,
          strokeDashArray: [2, 2]
        }))

        groupLineGrid.addWithUpdate(new fabric.Line([0, gridsize * x, this.canvas.width, gridsize * x], {
          stroke: "#DCEAEAFF",
          strokeWidth: 1,
          selectable: false,
          strokeDashArray: [2, 2]
        }))
      }
      this.canvas.add(groupLineGrid)
      // this.canvas.renderAll();
    },

  }
}
;
</script>

<style scoped lang="scss">
// VARIABLES  ―――――――――――――――――――――――――

$mainTint: #2c2f36;
$defaultTextColor: white;
$primaryColor: #4881b8;
$dangerColor: #e54f6b;
$controlsRatio: 1.3;


// GLOBAL ―――――――――――――――――――――――――

* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

body {
  display: flex;
  height: 100vh;
  font-size: 14px;
  background: $mainTint;
  color: $defaultTextColor;
  padding: 30px;
}

#wrapper {
  margin: auto;
}

#buildZone {
  display: flex;
}

.canvas-container, #canvas {
  transition: all 0.2 ease-in-out;
}

#canvas {
  background: rgba(248, 246, 246, 0.24);
  border-radius: 5px;
  border: 1px dashed #c1bdbd;
}


// CONTROLS  ―――――――――――――――――――――――――

#controls {
  margin-left: 20px;
  display: flex;
  flex-direction: column;

  i {
    background: $primaryColor;
    padding: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: #{$controlsRatio}em;
    border-radius: 100%;
    transition: all 0.2s ease-in-out;
    margin: 5px 0;

    &:hover {
      background: lighten($primaryColor, 8%);
      cursor: pointer;
    }
  }

  #clear {
    background: $dangerColor;
    margin-top: auto;

    &:hover {
      background: lighten($dangerColor, 8%);
    }
  }
}

// STYLE-ZONE  ―――――――――――――――――――――――――

#styleZone {
  display: flex;
  margin-top: 20px;

  span {
    width: 60px;
    height: 30px;
    border-radius: 3px;
    margin-right: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease-in-out;
    border: 2px solid transparent;

    &.isSelected i {
      opacity: 1;
      transform: scale(1);
    }

    &:hover, &.isSelected {
      cursor: pointer;
      border-color: $defaultTextColor;
    }
  }

  i {
    opacity: 0;
    transition: all 0.3s cubic-bezier(.56, .35, 0, 1.7);
    transform: scale(0.6);
  }
}

</style>
